import React from "react";
import { Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminMessages, AdminUIActionTypes, button_state, DataExportRequestStatus, Message, MessageHandlerDisplayType, MessageToastTypes, useAppDispatch } from "src/common";
import { PageHeader } from "src/components";
import { uiActions } from "src/store";

type AllProps = {
  handleAction: ActionHandlerFunction;
  step: keyof typeof DataExportRequestStatus;
  approvals_complete: boolean;
};

// Description: Header component for the data export page
function HeaderComponent(props: AllProps) {
  const { handleAction, step, approvals_complete } = props;
  const dispatch = useAppDispatch();
  const disable_start_export = (!approvals_complete || !!button_state[step as keyof typeof button_state]) && step !== DataExportRequestStatus.cancelled;
  const show_cancel = !button_state[step as keyof typeof button_state]; // step is not equal to complete, started, or running.
  const show_stop_export = step === DataExportRequestStatus.started || step === DataExportRequestStatus.running;

  // Description: Confirm canceling the data export request
  function confirmCancel() {
    const confirmation_dialog = new Message(
      AdminMessages.confirm_cancel_export_request.body,
      MessageHandlerDisplayType.confirm,
      MessageToastTypes.primary,
      AdminMessages.confirm_cancel_export_request.title,
      {
        label: "Yes",
        data: true,
        action: () => handleAction({ actionType: AdminUIActionTypes.Cancel })
      }
    );
    dispatch(uiActions.handleSetMessage(confirmation_dialog));
  }

  // Description: Confirm stopping the data export process
  function confirmStop() {
    const confirmation_dialog = new Message(
      AdminMessages.confirm_stop_export_process.body,
      MessageHandlerDisplayType.confirm,
      MessageToastTypes.primary,
      AdminMessages.confirm_stop_export_process.title,
      {
        label: "Yes",
        data: true,
        action: () => handleAction({ actionType: AdminUIActionTypes.StopDataExportRunning })
      }
    );
    dispatch(uiActions.handleSetMessage(confirmation_dialog));
  }

  return <PageHeader className="align-center justify-content-between">
    <h1 className="m-0">Data Export</h1>
    <div>
      {step !== DataExportRequestStatus.not_init && step !== DataExportRequestStatus.not_started && 
        <>
          <Button disabled={disable_start_export} onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })}>Start Export</Button>
          {show_cancel && (
            <Button
              variant="no-outline-primary"
              onClick={confirmCancel}
            >Cancel</Button>
          )}
          {show_stop_export && (
            <Button
              variant="no-outline-primary"
              onClick={confirmStop}
            >Stop Export</Button>
          )}
          {step !== DataExportRequestStatus.complete && step !== DataExportRequestStatus.cancelled && step !== DataExportRequestStatus.running && <Button
            variant="no-outline-primary"
            onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowSideNavMenu })}
          >Details</Button>}
          {step === DataExportRequestStatus.complete &&
            <Button
              variant="no-outline-primary"
              onClick={() => handleAction({ actionType: AdminUIActionTypes.Finish })}
            >Finish</Button>
          }
        </>
      }
    </div>
  </PageHeader>;
}

export default React.memo(HeaderComponent);